/**
 * Подробно об отведённых играх за период (26.10.2026, владелец: «по клику на количество уже отведённых игр — дропдаун
 * с подробной статистикой»). Сервер — GET /api/finance/games-stats (то же «отведено», что /api/finance/analytics).
 * Читают: плитка «Отведено» в финансах ЕО и большое число «отведено» на «Играх» ОО (GamesDonePop).
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";

export interface GsCount { name: string; games: number; revenue: number }
export interface GsBrief { id: number; date: string; time: string; quest: string }
export interface GamesStats {
  from: string; to: string; today: string;
  games: number; revenue: number; avgCheck: number; players: number;
  byBranch: GsCount[]; byQuest: GsCount[]; bySource: GsCount[]; byWeek: GsCount[]; weekday: number[];
  extras: { night: number; withMc: number; withTea: number; birthday: number; special: number };
  period: {
    booked: number; bookedPlayers: number; cancelled: number; learning: GsBrief[]; learningDone: GsBrief[];
    todayPending: number; pastNoReport: GsBrief[]; zeroReport: GsBrief[]; ahead: number; forecast: number;
    leadsOpen: GsBrief[]; leadsClosed: number; archived: number;
  };
}

/** Статистика периода; null — ещё грузится или сбой (error). Перезапрос — при смене периода. */
export function useGamesStats(from: string | null, to: string | null): { data: GamesStats | null; error: string | null } {
  const [data, setData] = useState<GamesStats | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!from || !to) return;
    let alive = true;
    setData(null); setError(null);
    api<GamesStats>(`/api/finance/games-stats?from=${from}&to=${to}`)
      .then((r) => { if (alive) setData(r); })
      .catch((e: unknown) => { if (alive) setError(e instanceof Error ? e.message : "Не удалось посчитать"); });
    return () => { alive = false; };
  }, [from, to]);
  return { data, error };
}

export const nfmt = (n: number) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
export const dmy = (iso: string) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
/** 1 игра, 2 игры, 5 игр. */
export function gamesWordRu(n: number): string {
  const a = Math.abs(n) % 100, b = a % 10;
  return a > 10 && a < 20 ? "игр" : b === 1 ? "игра" : b >= 2 && b <= 4 ? "игры" : "игр";
}
